import React from 'react';
import { useId } from "react-id-generator";
import FormRow from 'commons/components/FormFields/FormRow';
import ItemSelect from 'commons/components/ItemSelect';

interface ItemSelectFieldProps {
    className?: string,
    disabled?: boolean,
    error?: string,
    idPrefix?: string,
    items: any,
    label: string,
    name?: string,
    onChange?: (e: React.ChangeEvent) => void,
    onBlur?: (e: React.FocusEvent<HTMLDivElement, Element>) => void,
    placeholder?: string,
    readOnly?: boolean,
    rowClassName?: string,
    selectedItem?: string,
    tabIndex?: number,
    touched?: boolean
}

/**
 * Utilizes an ItemSelect to render a Formik form field.
 * 
 * @param {object} props 
 */
function ItemSelectField(props: ItemSelectFieldProps) {

    const inputId = props.idPrefix ?? useId(1, "itemSelect-")[0];
    const widgetRef = React.createRef();

    return (
        <FormRow 
            className={props.rowClassName}
            disabled={props.disabled}
            error={props.error}
            idPrefix={props.name}
            inputId={inputId + "Select"}
            label={props.label}
            renderErrorIcon={false}
            touched={props.touched}
            type="item-select"
        >
            <ItemSelect
                className={props.className}
                disabled={props.disabled}
                error={props.error ? true : false}
                idPrefix={inputId}
                items={props.items}
                name={props.name}
                onBlur={props.onBlur}
                onChange={(selectedItem) => { if (props.onChange) props.onChange(selectedItem); }}
                placeholder={props.placeholder}
                readOnly={props.readOnly}
                selectedItem={props.selectedItem}
                widgetRef={widgetRef}
            />
        </FormRow>
    );

}

ItemSelectField.defaultProps = {
    disabled: false,
    readOnly: false,
    touched: false
};

export default ItemSelectField;